"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _fluxActions = require("flux-actions");

var _PropertyTypes = _interopRequireDefault(require("../constants/PropertyTypes"));

var _createInitialState = _interopRequireDefault(require("./createInitialState"));

var _createStageForEditActionHandler = _interopRequireDefault(require("./createStageForEditActionHandler"));

var _createActionHandlerForProperty = _interopRequireDefault(require("./createActionHandlerForProperty"));

var _createActionHandlersForOrderedMapProperty = _interopRequireDefault(require("./createActionHandlersForOrderedMapProperty"));

var _createActionHandlersForNestedProperty = _interopRequireDefault(require("./createActionHandlersForNestedProperty"));

var _createStageOnRequestSuccessActionHandler = _interopRequireDefault(require("./createStageOnRequestSuccessActionHandler"));

/**
 * Creates a generic reducer to manage all actions related to updating a staged object.
 * @param properties The properties to monitor for change actions for.
 * @param actionTypes The object containing all supported actionTypes for the staged object.
 * @param objectType The type of staged object. Used to create unique action types.
 * @param requestSuccessActionType The action type for a successful domain object request, which will stage that data for edit.
 * @param requestSuccessDataSelector (optional) The callback function that will pull the relevant data from the payload response.
 * @param namespace (optional) The namespace for the staged object. Used to further distinguish unique action types.
 * @param actionHandlers (optional) A set of custom action handlers to augment the reducer with.
 * @returns {*} The fully functional reducer for the staged object.
 */
var _default = function _default(_ref) {
  var properties = _ref.properties,
      actionTypes = _ref.actionTypes,
      objectType = _ref.objectType,
      _ref$requestSuccessAc = _ref.requestSuccessActionType,
      requestSuccessActionType = _ref$requestSuccessAc === void 0 ? null : _ref$requestSuccessAc,
      _ref$requestSuccessDa = _ref.requestSuccessDataSelector,
      requestSuccessDataSelector = _ref$requestSuccessDa === void 0 ? null : _ref$requestSuccessDa,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? "" : _ref$namespace,
      _ref$actionHandlers = _ref.actionHandlers,
      actionHandlers = _ref$actionHandlers === void 0 ? {} : _ref$actionHandlers;
  var initialActionHandlers = Object.assign(actionHandlers, requestSuccessActionType ? (0, _createStageOnRequestSuccessActionHandler.default)({
    properties: properties,
    objectType: objectType,
    requestSuccessActionType: requestSuccessActionType,
    requestSuccessDataSelector: requestSuccessDataSelector
  }) : {}, (0, _createStageForEditActionHandler.default)({
    namespace: namespace,
    properties: properties,
    objectType: objectType
  }));
  return (0, _fluxActions.handleActions)(properties.reduce(function (acc, property) {
    if (typeof property === "string") {
      return Object.assign(acc, (0, _createActionHandlerForProperty.default)({
        actionTypes: actionTypes,
        property: property
      }));
    } else if ((0, _typeof2.default)(property) === "object" && property.type) {
      if (property.type === _PropertyTypes.default.SIMPLE) {
        return Object.assign(acc, (0, _createActionHandlerForProperty.default)({
          actionTypes: actionTypes,
          property: property.key
        }));
      } else if (property.type === _PropertyTypes.default.ORDERED_MAP) {
        return Object.assign(acc, (0, _createActionHandlersForOrderedMapProperty.default)({
          actionTypes: actionTypes,
          property: property.key
        }));
      } else if (property.type === _PropertyTypes.default.NESTED) {
        return Object.assign(acc, (0, _createActionHandlersForNestedProperty.default)({
          actionTypes: actionTypes,
          property: property
        }));
      }
    }
  }, initialActionHandlers), (0, _createInitialState.default)(properties));
};

exports.default = _default;
module.exports = exports.default;